export interface MockDataVariants {
  [key: string]: string[];
}

export const MOCK_DATA_BY_KEY: MockDataVariants = {
  // Add key-specific overrides here if needed
};

export const MOCK_DATA_BY_INPUT_TYPE: Record<string, string[]> = {
  textarea: [
    'Professional cleaner with 8+ years of experience in residential and commercial properties. Specialized in deep cleaning, move-in/move-out, and eco-friendly products.',
    'Dedicated cleaning professional focused on attention to detail. Experienced with luxury homes, Airbnb turnovers, and office spaces. Fully insured and bonded.',
    'I bring 5 years of professional cleaning expertise to every job. Known for reliability, thoroughness, and excellent communication with clients.',
    'Experienced home care specialist offering premium cleaning services. Certified in green cleaning methods. Available for recurring and one-time appointments.',
    'Passionate about creating spotless, healthy living spaces. Over a decade of experience serving families and businesses in the metro area.',
    'Detail-oriented cleaning professional with strong references. I treat every home as if it were my own. Specializing in organizing and deep sanitization.',
    'Bilingual cleaning expert (English/Spanish) with 7 years of professional experience. Background in hospitality and residential cleaning.',
    'Certified cleaning technician with training in OSHA safety standards. Expert in allergen reduction, pet-friendly cleaning, and post-construction cleanup.',
    'Reliable and trustworthy cleaning professional. I pride myself on punctuality and consistent quality. Serving the community for over 6 years.',
    'Small business owner specializing in residential cleaning. My team and I focus on exceeding expectations with every visit. Licensed and insured.',
  ],
  url: [
    'https://www.example.com/cleaning-pro-portfolio',
    'https://www.linkedin.com/in/cleaning-professional-12345',
    'https://www.yelp.com/biz/sparkle-cleaning-services',
    'https://www.facebook.com/CleanHomePros',
    'https://www.instagram.com/spotless_cleaning_co',
    'https://www.google.com/maps/place/PremierClean+Services',
    'https://www.thumbtack.com/pro/clean-home-experts',
    'https://www.nextdoor.com/pages/pristine-cleaning-llc',
    'https://twitter.com/CleanTeamPro',
    'https://www.homeadvisor.com/rated.CleanSweepServices.html',
  ],
  number: [
    '3', '5', '7', '10', '12', '15', '8', '20', '6', '25',
  ],
  file: [
    'https://picsum.photos/seed/cert1/400/300',
    'https://picsum.photos/seed/cert2/400/300',
    'https://picsum.photos/seed/cert3/400/300',
    'https://picsum.photos/seed/cert4/400/300',
    'https://picsum.photos/seed/cert5/400/300',
    'https://picsum.photos/seed/cert6/400/300',
    'https://picsum.photos/seed/cert7/400/300',
    'https://picsum.photos/seed/cert8/400/300',
    'https://picsum.photos/seed/cert9/400/300',
    'https://picsum.photos/seed/cert10/400/300',
  ],
  profile_image: [
    'https://picsum.photos/seed/face1/200/200',
    'https://picsum.photos/seed/face2/200/200',
    'https://picsum.photos/seed/face3/200/200',
    'https://picsum.photos/seed/face4/200/200',
    'https://picsum.photos/seed/face5/200/200',
    'https://picsum.photos/seed/face6/200/200',
    'https://picsum.photos/seed/face7/200/200',
    'https://picsum.photos/seed/face8/200/200',
    'https://picsum.photos/seed/face9/200/200',
    'https://picsum.photos/seed/face10/200/200',
  ],
};
